import '../chunk-7P6ASYW6.mjs';

// constants/password.ts
var PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
var PASSWORD_MESSAGE = "Must contain one number and one letter, be at least 8 characters long, contain one of the following special characters !@#$%^&* and no other symbols";

export { PASSWORD_MESSAGE, PASSWORD_REGEX };
